import { SaplingMark } from '../ui/SaplingMark'

/**
 * The empty thread.
 *
 * The prompts are examples of what this collaboration is FOR — planning,
 * noticing, making, and asking. They are not a menu of features; the point is
 * that anything can be typed here.
 */
export function EmptyThread({
  childName, onPick,
}: {
  childName: string
  onPick: (text: string) => void
}) {
  const prompts = [
    `Plan tomorrow for ${childName}`,
    `What has changed in the last month?`,
    `Make a counting game about dinosaurs`,
    `She won't sit still for anything today. What should I do?`,
  ]

  return (
    <div className="empty-thread">
      <div className="empty-thread-mark" aria-hidden="true">
        <SaplingMark size={44} tone="brand" />
      </div>

      <h2 className="empty-thread-title">What's on your mind?</h2>
      <p className="empty-thread-body">
        Tell me what happened, ask me to plan something, or ask me to make
        something for {childName}. I remember everything we've worked on.
      </p>

      <div className="empty-thread-prompts">
        {prompts.map((p) => (
          <button key={p} className="empty-thread-prompt" onClick={() => onPick(p)}>
            {p}
          </button>
        ))}
      </div>
    </div>
  )
}
